export default __webpack_public_path__ + "static/media/scooter.9d044bb0.svg";